import GenerateInviteLinkComponent from '../Components/GenerateInviteLinkComponent';

function GenerateInviteLinkPage() {
  return <GenerateInviteLinkComponent menuName="Generate Invite Link" />;
}

export default GenerateInviteLinkPage;
